import { Typography } from '@euler/app/components/typography';
import { FloatingModalScreen } from '@euler/app/tv/components/FloatingModalScreen';
import { tvModalScreenOptions } from '@euler/app/tv/functions/utils';
import { usePresentationTheme } from '@euler/app/tv/theme';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { updateCheckingLogs$ } from '@euler/functions/useCheckForUpdates';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { formatDateTime } from '@euler/utils/formatters';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { ScrollView, Text, View } from 'react-native';

export const DebugPanel = wrapNavigatorScreen(() => {
  const [updateLogs] = useBehaviorSubject(updateCheckingLogs$);
  const theme = usePresentationTheme();
  const { rpx } = useResponsiveContext();

  return (
    <FloatingModalScreen>
      <ScrollView
        contentContainerStyle={{
          padding: rpx(30),
        }}
        css={`
          height: ${rpx(550)}px;
        `}
      >
        <Text
          css={`
            color: ${theme.debugPanel.sectionTitleTextColor};
            font-family: ${FontFamily.NotoSans.Medium};
            font-size: ${rpx(20)}px;
            line-height: ${rpx(32)}px;
            margin-bottom: ${rpx(20)}px;
          `}
        >
          Updates Checking Logs
        </Text>
        {updateLogs.map(log => (
          <View
            key={log.id}
            css={`
              border-bottom-width: 0.5px;
              border-bottom-color: ${theme.debugPanel.logSeparatorColor};
              padding: ${rpx(8)}px 0;
            `}
          >
            <Typography.Label
              light
              size={rpx(18)}
              color={theme.debugPanel.logTextColor}
            >{`[${formatDateTime(log.timestamp, 'HH:mm:ss')}]${
              log.message
            }`}</Typography.Label>
          </View>
        ))}
      </ScrollView>
    </FloatingModalScreen>
  );
}, tvModalScreenOptions);
